import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { WorkflowType } from '@ca/core/models';

export class WorkflowValidators {
    static defaultType(currentlyDefault: boolean, currentType: WorkflowType): ValidatorFn {
        return (control: UntypedFormGroup): ValidationErrors | null => {
            const type = control.get('type');
            const isDefaultForType = control.get('isDefaultForType');
            if (currentlyDefault && isDefaultForType && !isDefaultForType.value) {
                return { defaultUnselected: true };
            }
            if (!type) {
                return null;
            }
            if (currentType !== type.value && isDefaultForType && isDefaultForType.value) {
                return { changeDefaultType: true };
            }
            return type && isDefaultForType && type.value === WorkflowType.UNDEFINED && isDefaultForType.value ? { defaultForUndefined: true } : null;
        };
    }
}
